import { render, staticRenderFns } from "./prefixIcon-editor.vue?vue&type=template&id=28d62b7a&scoped=true&"
import script from "./prefixIcon-editor.vue?vue&type=script&lang=js&"
export * from "./prefixIcon-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d62b7a",
  null
  
)

export default component.exports